import { render, staticRenderFns } from "./ImageExternal.vue?vue&type=template&id=63062e6c&scoped=true"
import script from "./ImageExternal.vue?vue&type=script&lang=ts"
export * from "./ImageExternal.vue?vue&type=script&lang=ts"
import style0 from "./ImageExternal.vue?vue&type=style&index=0&id=63062e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63062e6c",
  null
  
)

export default component.exports